import { render } from "./SelectIconButton.vue?vue&type=template&id=2ec0391e&scoped=true"
import script from "./SelectIconButton.vue?vue&type=script&lang=js"
export * from "./SelectIconButton.vue?vue&type=script&lang=js"

import "./SelectIconButton.vue?vue&type=style&index=0&id=2ec0391e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ec0391e"

export default script